import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-commercial',
  templateUrl: './card-commercial.component.html',
  styleUrls: ['./card-commercial.component.scss']
})
export class CardCommercialComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
